import axios, { AxiosInstance } from 'axios'
import NProgress from 'nprogress'
import authService from './auth-service'

export default (timeout: number = 15000): AxiosInstance => {
  // create axios instance
  const instance = axios.create({
    //baseURL: process.env.VUE_APP_API_BASE_PATH,
    baseURL: import.meta.env.VITE_API_BASE_URL,
    timeout: timeout,
    // validateStatus: () => false
  })

  // add interceptors
  instance.interceptors.request.use(
    (config) => {
      NProgress.start()
      // Add X-Access-Token header to every request, you can add other custom headers here
      if (authService.hasAccessToken()) {
        if (!config.headers) {
          config.headers = {}
        }
        config.headers['X-Access-Token'] = authService.getAccessToken()
        config.headers.authorization = `Bearer ${authService.getAccessToken()}`
      }
      return config
    },
    (error) => {
      Promise.reject(error)
    },
  )

  instance.interceptors.response.use(
    (response) => {
      NProgress.done()
      return response
    },
    (error) => {
      console.error(error)
      NProgress.done()
      if (error.response && error.response.status === 401) {
        authService.logout().then(() => {
          location.replace('/auth/login')
        })
      }
      if (error.response && error.response.status === 403) {
        location.replace('/403')
      }
      return Promise.reject(error)
    },
  )

  // return instance
  return instance
}
